// import Sticky from "sticky-js";
// import { h, render } from "preact";
// import StickyBox from "react-sticky-box";

export default function appSticky(stickybox, config) {
  config = {
    offsetTop: 0,
    minWidth: 993,
    ...config,
  };
  if (!stickybox) return;

  function checkPosition() {
    stickybox.style.transition = "top 0.1s";
    stickybox.style.position = "sticky";
    stickybox.style.top = `${config.offsetTop}px`;
  }

  if (window.innerWidth >= config.minWidth) {
    window.addEventListener("scroll", checkPosition);
    checkPosition();
  }

  window.addEventListener("resize", () => {
    if (window.innerWidth >= config.minWidth) {
      window.addEventListener("scroll", checkPosition);
    } else {
      window.removeEventListener("scroll", checkPosition);
      stickybox.style.position = "relative";
      stickybox.style.top = "0";
    }
  });
}
